import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import React from 'react'
import { observer } from 'mobx-react'
import { discountMobx } from 'restaurant'
import { format } from '@dt/fe-utils'
import { Icon, ProductImage } from '@cps'
import './index.scss'

interface IProps {
  reject?: () => void;
  resolve?: (product: any) => void;
}

const FullOffModal: React.FC<IProps> = (props) => {
  const handleChooseProduct = (product) => {
    props.resolve(product)
  }

  const handleClose = () => {
    props.reject()
  }

  const Product = (product: IViewProduct) => (
    <div className='fulloff-product-item' onClick={() => handleChooseProduct(product)}>
      <ProductImage imgSrc={product.pic} width={80} />
      <div className='fulloff-product-info'>
        <div className='fulloff-product-name'>
          <h3>{product.name}</h3>
        </div>
        <div className='fulloff-product-price'>
          <div className='price-info'>
            <span dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(product.actualPrice) }}></span>
            {product.actualPrice !== product.price && <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(product.price) }}></del>}
          </div>
          <Icon name='tianjia' />
        </div>
      </div>
    </div>
  )

  return (
    <IonModal
      cssClass='fulloff-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        <div className='fulloff-modal-title'>{i18n.t('menu.activityVip')}</div>
      </IonHeader>
      <IonContent className='fulloff-modal-content'>
        <div className='fulloff-desc'>
          <h4>{i18n.t('menu.fullOff.partinProduct', { name: discountMobx.discountResult?.designatedBuyAgain?.activityName })}</h4>
          {i18n.t('menu.activityExplain')}
        </div>
        <div className='fulloff-products-list'>
          {discountMobx.designatedBuyAgainProducts?.map((item) => (
            <Product key={item.no} {...item} />
          ))}
        </div>
      </IonContent>
      <IonFooter>
        <button className='default-btn' onClick={handleClose}>
          {i18n.t('newCart.backCart')}
        </button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(FullOffModal)
